import { useMutation, useQueryClient } from "@tanstack/react-query";
import { usePartyApi } from "../api/party-api";
import type {
  CeremonyTicket,
  ConfirmLinkInput,
  LinkResult,
  RedeemInput,
  StartLinkInput,
} from "../api/contracts";

// The linking ceremony hooks (party realm, unlinked caller). On a LINKED outcome the
// caller invalidates the profile query so the gate flips from onboarding to the shell.
export function useInvalidateProfile() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ["customer", "profile"] });
}

/** POST /v1/customer/link/start — always returns a ceremony ticket (uniform). */
export function useStartLink() {
  const api = usePartyApi();
  return useMutation({
    mutationFn: (input: StartLinkInput) =>
      api.post<CeremonyTicket>("/v1/customer/link/start", input),
  });
}

/** POST /v1/customer/link/confirm — the uniform outcome (LINKED/DENIED/LOCKED). */
export function useConfirmLink() {
  const api = usePartyApi();
  return useMutation({
    mutationFn: (input: ConfirmLinkInput) =>
      api.post<LinkResult>("/v1/customer/link/confirm", input),
  });
}

/** POST /v1/customer/link/redeem — Path A; works during a self-service lockout. */
export function useRedeem() {
  const api = usePartyApi();
  return useMutation({
    mutationFn: (input: RedeemInput) => api.post<LinkResult>("/v1/customer/link/redeem", input),
  });
}
